import { render, staticRenderFns } from "./ArticleListing.vue?vue&type=template&id=a18d4106&scoped=true"
import script from "./ArticleListing.vue?vue&type=script&lang=js"
export * from "./ArticleListing.vue?vue&type=script&lang=js"
import style0 from "./ArticleListing.vue?vue&type=style&index=0&id=a18d4106&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18d4106",
  null
  
)

export default component.exports